import React from "react";
import type { Subtract } from "utility-types";

export const MapContext = React.createContext<readonly string[] | undefined>(undefined);

export function useMapContext() {
    return React.useContext(MapContext);
}

interface WithMapContextProps {
    readonly mapContext: readonly string[] | undefined;
}

export const withMapContext = <P extends WithMapContextProps>(
    Component: React.ComponentType<P>
): React.FunctionComponent<Subtract<P, WithMapContextProps>> => p => {
    const mapContext = useMapContext();
    return <Component {...(p as P)} mapContext={mapContext} />;
};
